import React from 'react';
import PaymentPending from '../../components/Payments/PaymentPending';

const Pending = () => {
  return <PaymentPending />;
};

export default Pending;
